import { wrappedFetch } from "./urlFunctions";
import API from "./urlConstants";


export const dashboardData = () => {
    return wrappedFetch(API.DB_DATA, "GET");
}
export const fetchNotification = () => {
    return wrappedFetch(API.FETCH_NOTIFICATION, "GET");
}